import Rails from "@rails/ujs";

import "./components/sortable_table";
import "./components/geo_address";
import "./components/massive";

Rails.start();
